import { Company } from "../client/typesDefinition";
import { Invoice } from "../invoice/typesDefinition";
import { Entity, Response } from "../typesDefinition";
import { StatusLabelsKey } from "./utils";

export interface OrderLine extends Entity {
  projectRoleName: string;
  hourlyRate: number;
  quantity: number;
  unit: TimeUnit;
}

export interface Order extends Entity {
  title: string;
  startDate: string;
  endDate: string;
  status: StatusLabelsKey;
  notes?: string;
  legalNotice?: string;
  orderLines: OrderLine[];
  paymentOption: string;
  invoiced?: boolean;
  invoice: Invoice;
  company: Company;
  price: number;
  showDetailsOnInvoice: boolean;
  isFirstOrder: boolean;
  dueDate: string;
}

export interface RecurringOrder extends Entity {
  title: string;
  startDate: string;
  endDate: string;
  status: StatusLabelsKey;
  notes?: string;
  legalNotice?: string;
  orderLines: OrderLine[];
  paymentOption: string;
  invoice: Invoice;
  company: Company;
  price: number;
  showDetailsOnInvoice: boolean;
  isFirstOrder: boolean;
}

export interface ordersAndInvoicesResponse {
  ordersAndInvoices: (Order | Invoice)[];
}

export interface RecurringOrderResponse {
  recurringOrders: RecurringOrder[];
}

export type CreateRecurringOrderResponse = Response<RecurringOrder>;

export type CreateOrderResponse = Response<Order>;

export enum TimeUnit {
  MINUTE = "minute",
  HOUR = "hour",
  DAY = "day",
}

export enum PaymentOption {
  PRE_PAID = "pre_paid",
  POST_PAID = "post_paid",
}
